import React from "react";
import atoms from "../../../atoms";
import molecules from "../../../molecules";
import { useParams } from "react-router";
import constant from "../../../../constants/constant";
const { Input, Button, Select } = atoms;
const { CheckboxDropdown, TopBar } = molecules;

const AddRole = ({
    structuredPermission,
    defaultPermission,
    rolesDetails,
    handleRoleChange,
    roleError,
    handleChange,
    _handleCheckboxChange,
    handleClick
}: any) => {
    let params = useParams();
    let roleID: string = params.id || "";

    return (
        <div>
            <div className="col-6">
                <TopBar heading={"Add Role"} />
            </div>
            <div className="row mt-3">
                <div className="col-4">
                    <Input
                        label={"Role"}
                        type={"text"}
                        placeholder={"Enter Role"}
                        value={rolesDetails?.role_name}
                        onChange={(e: any) => {
                            handleChange("role_name", e.target.value);
                        }}
                        errors={!rolesDetails?.role_name && roleError.name}
                    />
                </div>
                <div className="col-4">
                    <Select
                        className="w-100"
                        label={"Role For"}
                        placeholder={"Select Role For"}
                        value={rolesDetails?.role_for}
                        options={constant.ROLE_FOR?.slice(0, 2)}
                        onChange={(e: any) => handleRoleChange(e)}
                        errors={!rolesDetails?.role_for && roleError.role_for}
                    />
                </div>
                <div className="col-4"></div>
            </div>
            <div className="row mt-3">
                {rolesDetails?.role_for && (
                    <div className="col-6">
                        <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
                            Role Permissions
                        </label>
                        <div className="member-permission">
                            <CheckboxDropdown
                                structuredPermission={structuredPermission}
                                handleCheckboxChange={(codeArr: []) =>
                                    _handleCheckboxChange(codeArr)
                                }
                                defaultPermission={defaultPermission}
                            />
                        </div>
                        {roleError.role && rolesDetails?.permissions?.length === 0 && (
                            <span className="error-text">{roleError.role}</span>
                        )}
                    </div>
                )}
                <div className="justify-content-center d-flex mt-4">
                    <Button
                        name={`${roleID ? "Update Role" : "Add Role"}`}
                        className={"w-25 m-4 "}
                        onClick={() => handleClick()}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddRole;
